import React from "react";
import PropTypes from "prop-types";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import Position from "./Position";

function sortPriority(a, b) {
  return a.priority - b.priority;
}

const NonPositions = () => (
  <tr>
    <td colSpan={4} className="text-center">
      No positions found.
    </td>
  </tr>
);

const Positions = ({
  data,
  allPositions,
  onDelete,
  onSave,
  onRemove,
  onDragEnd
}) => (
  <DragDropContext onDragEnd={onDragEnd}>
    <table className="table table-clean table-white table-draggable">
      <thead>
        <tr>
          <th />
          <th>Name</th>
          <th>Code</th>
          <th>Hourly Rate</th>
          <th />
        </tr>
      </thead>

      <Droppable droppableId="table">
        {droppableProvided => (
          <tbody
            ref={ref => {
              droppableProvided.innerRef(ref);
            }}
            {...droppableProvided.droppableProps}
          >
            {data.sort(sortPriority).map((item, index) => (
              <Draggable
                index={index}
                draggableId={item.id || item._id}
                key={item.id || item._id}
              >
                {(provided, snapshot) => (
                  <Position
                    provided={provided}
                    snapshot={snapshot}
                    data={item}
                    edit={item.id === null}
                    allPositions={allPositions}
                    addedIds={data
                      .map(d => d.positionId)
                      .filter(id => id !== item.positionId)}
                    onDelete={onDelete}
                    onSave={onSave}
                    onRemove={onRemove}
                  />
                )}
              </Draggable>
            ))}

            {data.length === 0 ? <NonPositions /> : null}
          </tbody>
        )}
      </Droppable>
    </table>
  </DragDropContext>
);

Positions.defaultProps = {
  data: PropTypes.array.isRequired,
  allPositions: PropTypes.array,
  onDelete: PropTypes.func,
  onSave: PropTypes.func,
  onRemove: PropTypes.func,
  onDragEnd: PropTypes.func
};

export default Positions;
